

































import { Component, Mixins } from 'vue-property-decorator'
import AuthService from '@/services/auth-service'
import SnackbarService from '@/services/snackbar-service'

@Component({
  components: {},
})
export default class LoginView extends Mixins(AuthService, SnackbarService) {
  pass1 = ''
  pass2 = ''
  errorMessages: string[] | null = []

  token = ''

  passwordsValid = true
  triedSend = false

  created() {
    this.token = this.$route.params.token
  }

  resetPassword() {
    this.triedSend = true
    this.validatePasswords()
    if (!this.passwordsValid) {
      return
    }
    this.sendResetPassword(this.pass1, this.token).then((res: any) => {
      console.log(res.data)
    })
  }

  passwordsEqual() {
    return !this.triedSend ? true : this.pass1 === this.pass2
  }

  passwordsStrong() {
    return !this.triedSend
      ? true
      : this.pass1.length >= 5 && this.pass2.length >= 5
  }

  validatePasswords() {
    if (!this.triedSend) {
      this.errorMessages = null
      this.passwordsValid = true
    } else {
      this.passwordsValid = this.passwordsEqual() && this.passwordsStrong()
      if (!this.passwordsValid) {
        this.errorMessages = []
      } else {
        this.errorMessages = null
      }
      if (!this.passwordsEqual()) {
        this.errorMessages.push('Passwords dont match')
      }
      if (!this.passwordsStrong()) {
        this.errorMessages.push('Password must be at least 5 characters long')
      }
    }
  }
}
